import React from 'react';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { BUTTON_SIZES, BUTTON_VARIANTS, GhostButton, IconButton } from 'ui/button';
import { InputText } from 'ui/inputs';
import { Delete24, Add16 } from 'ui/icons';

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: ${spacing.half};
  margin-bottom: 10px;
`;

type HttpHeader = {
  key: string;
  value: string;
};

type Props = {
  existingHeaders: HttpHeader[];
  onHeadersChange: (next: HttpHeader[]) => void;
};

const CustomHTTPHeaders = ({ existingHeaders: headers = [], onHeadersChange }: Props) => {
  const handleAdd = () => onHeadersChange([...headers, { key: '', value: '' }]);

  const handleEdit = (value: string, idx: number, objectKey: string) => {
    const next = headers.map((header, i) =>
      i === idx ? { ...header, [objectKey]: value } : header,
    );
    onHeadersChange(next);
  };

  const handleDelete = (idx: number) => onHeadersChange([...headers].filter((_, i) => i !== idx));

  return (
    <React.Fragment>
      {headers.map(({ key, value }, idx) => {
        const keyTag = `customHTTPHeaderKey-${idx}`;
        const valueTag = `customHTTPHeaderValue-${idx}`;
        return (
          <GridRow key={`customHTTPHeader${idx}`}>
            <InputText
              id={keyTag}
              value={key}
              placeholder="Key"
              data-test={keyTag}
              onChange={(val: string) => {
                handleEdit(val, idx, 'key');
              }}
            />
            <InputText
              id={valueTag}
              value={value}
              placeholder="Value"
              data-test={valueTag}
              onChange={(val: string) => {
                handleEdit(val, idx, 'value');
              }}
            />
            <IconButton
              size={BUTTON_SIZES.LARGE}
              variant={BUTTON_VARIANTS.SECONDARYDESTRUCTIVE}
              onClick={() => handleDelete(idx)}
              data-test={`deleteCustomHeader-${idx}`}
            >
              <Delete24 />
            </IconButton>
          </GridRow>
        );
      })}
      <GhostButton data-test="addHTTPHeader" onClick={handleAdd}>
        <Add16 />
        Add HTTP Header
      </GhostButton>
    </React.Fragment>
  );
};

export default CustomHTTPHeaders;
